"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const SidebarTabPanel = (props) => {
    const { content, disableGutters = false, primaryHeader, primaryTypographyProps, secondaryHeader, secondaryTypographyProps, selectedValue, value, ...other } = props;
    return (react_1.default.createElement(Box_1.default, { component: "div", role: "tabpanel", hidden: selectedValue !== value, id: `sidebar-tabpanel-${value}`, sx: ({ spacing }) => ({
            "& > *:not(hr)": {
                padding: disableGutters ? spacing(2, 0) : spacing(2),
            },
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            overflowY: "scroll",
            width: "100%",
        }), ...other },
        primaryHeader && (react_1.default.createElement(react_1.default.Fragment, null,
            primaryHeader && (react_1.default.createElement(Typography_1.default, { variant: "h6", color: "textPrimary", ...primaryTypographyProps },
                primaryHeader,
                secondaryHeader && (react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", sx: { pt: (theme) => theme.spacing(1) }, ...secondaryTypographyProps }, secondaryHeader)))),
            react_1.default.createElement(Divider_1.default, null))),
        react_1.default.createElement("div", null, typeof content === "function" ? content({ selectedValue, value }) : content)));
};
exports.default = SidebarTabPanel;
